<ds-modal
  [heading]="autopayPromotionDetails.modalHeading | translate"
  [variant]="modalVariant"
  (closeClick)="close('cancel')"
  [closeCaption]="'overview.autopay-promo.details.close-caption' | translate"
  [iconCaption]="totalAutopayPromotions === 0 ? ('overview.autopay-promo.details.icon-caption' | translate) : ''"
>
  <div body>
    <fss-autopay-promo-details-body
      [language]="language"
      [autopayPromotionDetails]="autopayPromotionDetails"
      [dateFormat]="dateFormat"
      [totalAutopayPromotions]="totalAutopayPromotions"
    ></fss-autopay-promo-details-body>
  </div>
  <div footer>
    @if (autopayPromotionDetails.isEnroll) {
      @if (totalAutopayPromotions > 0) {
        <button
          ds-button
          [attr.aria-label]="'overview.autopay-promo.details.setup-cta-alt' | translate"
          [attr.title]="'overview.autopay-promo.details.setup-cta-alt' | translate"
          (click)="navigate()"
        >
          {{ 'overview.autopay-promo.details.setup-cta' | translate }}
        </button>
      }
      <button
        ds-button
        [variant]="totalAutopayPromotions > 0 ? 'tertiary' : 'primary'"
        [attr.title]="'overview.autopay-promo.details.cancel-alt' | translate"
        [attr.aria-label]="'overview.autopay-promo.details.cancel-alt' | translate"
        (click)="close()"
      >
        {{ 'common.cancel' | translate }}
      </button>
    } @else {
      @if (totalAutopayPromotions > 0) {
        <button
          ds-button
          [attr.aria-label]="'autopay-de-enrollment.continue-alt' | translate"
          [attr.title]="'autopay-de-enrollment.continue-alt' | translate"
          (click)="close()"
        >
          {{ 'autopay-de-enrollment.continue' | translate }}
        </button>
        <button
          ds-button
          [variant]="'tertiary'"
          [attr.title]="'autopay-de-enrollment.keep-autopay-alt' | translate"
          [attr.aria-label]="'autopay-de-enrollment.keep-autopay-alt' | translate"
          (click)="navigate('overview')"
        >
          {{ 'autopay-de-enrollment.keep-autopay' | translate }}
        </button>
      } @else {
        @if (totalAutopayPromotions === 0) {
          <button
            ds-button
            [variant]="'primary'"
            [attr.title]="'overview.autopay-promo.details.cancel-alt' | translate"
            [attr.aria-label]="'overview.autopay-promo.details.cancel-alt' | translate"
            (click)="close()"
          >
            {{ 'common.cancel' | translate }}
          </button>
        }
      }
    }
  </div>
</ds-modal>
